/**
 * `POST /Otp/send` — endpoint **public** du user-service (guide v2.3 §6.9).
 *
 * Envoyé en amont de l'inscription : le téléphone / email est vérifié avant
 * la création du compte Keycloak, donc l'existence d'un jeton. Encadré par
 * trois quotas PAR DESTINATAIRE : délai minimal entre deux envois (défaut
 * 60 s), plafond horaire (défaut 5), plafond de tentatives de vérification
 * (défaut 5). 422 si dépassé. Jamais le code lui-même en réponse.
 */
import { useMutation } from "@tanstack/react-query";

import { mutatePublicData } from "@/core/api/api-methods";
import {
  apiErrorHandler,
  getBackendErrorMessage,
} from "@/core/api/api-error-handler";
import { logger } from "@/core/utils/func/logger";
import { authEndpoints } from "@/features/auth/api/endpoints";
import type {
  OtpSendRequest,
  OtpSendResponse,
} from "@/features/auth/api/dto";

export const useSendOtp = () =>
  useMutation({
    mutationKey: ["auth", "otp", "send"],
    mutationFn: (body: OtpSendRequest) =>
      mutatePublicData({
        url: authEndpoints.otp.send,
        reqBody: body as unknown as Record<string, unknown>,
        method: "POST",
      }) as Promise<OtpSendResponse>,
    onError: (error) => {
      const message = getBackendErrorMessage(error) ?? apiErrorHandler(error);
      logger.error(
        `useSendOtp failed: ${message}`,
        error instanceof Error ? error : undefined,
        { prefix: "auth" }
      );
    },
  });
